"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/web.dom.iterable");

























































































var _lodash = _interopRequireDefault(require("lodash")); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/** import { validUsername } from '@/utils/validate'*/var _default = { name: 'Login', data: function data() {/** const validateUsername = (rule, value, callback) => {
                                                                                                               if (!validUsername(value)) {
                                                                                                                 callback(new Error('请输入名称'))
                                                                                                               } else {
                                                                                                                 callback()
                                                                                                               }
                                                                                                             }*/var validatePassword = function validatePassword(rule, value, callback) {if (value.length < 6) {callback(new Error('密码不能少于6位'));} else {callback();}};return { title: '家用物联云平台', switchEnvText: { test: '测试环境', dev: '开发环境', internal: '国内正式版', overseas: '海外正式版' }, switchEnv: { name1: '测试环境', name2: '开发环境' }, switchEnvUrl: { test: '47.96.169.127:4003', // 测试环境
        dev: '192.168.70.115:4003', // 开发
        internal: 'familyiot.cozzia.com.cn/', // 国内
        overseas: 'familyiot-gl.cozzia.com.cn' // 海外
      }, loginForm: { username: '', password: '' }, loginRules: { username: [{ required: true, trigger: 'blur', message: '请输入用户名' }], password: [{ required: true, trigger: 'blur', validator: validatePassword }] }, loading: false, passwordType: 'password', redirect: undefined };}, mounted: function mounted() {var _this = this;console.log('当前编译环境========>', process.env);var url = window.location.href;document.onkeydown = function (event) {var e = event || window.event; // || arguments.callee.caller.arguments[0]
      if (e && e.keyCode === 13 && _this.$route.path === '/login') {// enter 键
        _this.handleLogin();}};if (url.indexOf(this.switchEnvUrl.test) !== -1) {this.switchEnv.name1 = this.switchEnvText.test;this.switchEnv.name2 = this.switchEnvText.dev;}if (url.indexOf(this.switchEnvUrl.dev) !== -1) {this.switchEnv.name1 = this.switchEnvText.dev;this.switchEnv.name2 = this.switchEnvText.test;}if (url.indexOf(this.switchEnvUrl.internal) !== -1) {this.switchEnv.name1 = this.switchEnvText.internal;this.switchEnv.name2 = this.switchEnvText.overseas;}if (url.indexOf(this.switchEnvUrl.overseas) !== -1) {this.switchEnv.name1 = this.switchEnvText.overseas;this.switchEnv.name2 = this.switchEnvText.internal;} // if (url.indexOf('localhost') || url.indexOf('127.0.0.1')) {
    //   this.switchEnv.name1 = '本地环境'
    //   this.switchEnv.name2 = null
    // }
    this.$store.dispatch('app/setEnv', this.switchEnv.name1);}, computed: { envList: function envList() {var env = process.env.VUE_APP_OG_ENV;console.log('process.env.VUE_APP_OG_ENV=========>', env);var list = [];if (env.toLowerCase().indexOf('development') >= 0) {//测试环境
        list = [{ name: '国内-测试', url: 'http://47.96.169.127:4003' }, { name: '海外-测试', url: 'http://na-console-test.ogawaiot.com/' }];if (env == 'americaDevelopment') {list = _lodash.default.reverse(list);}} else {//生产环境
        if (env == 'production') {list = [{ name: '国内-生产', url: 'http://familyiot.cozzia.com.cn/' },

          {
            name: '亚洲区-生产',
            url: 'http://familyiot-gl.cozzia.com.cn/' },

          {
            name: '美洲区-生产',
            url: 'https://na-console.ogawaiot.com/' }];


        }
        if (env == 'asiaProduction') {
          list = [
          {
            name: '亚洲区-生产',
            url: 'http://familyiot-gl.cozzia.com.cn/' },

          {
            name: '国内-生产',
            url: 'http://familyiot.cozzia.com.cn/' },

          {
            name: '美洲区-生产',
            url: 'https://na-console.ogawaiot.com/' }];


        }
        if (env == 'americaProduction') {
          list = [
          {
            name: '美洲区-生产',
            url: 'https://na-console.ogawaiot.com/' },

          {
            name: '国内-生产',
            url: 'http://familyiot.cozzia.com.cn/' },

          {
            name: '亚洲区-生产',
            url: 'http://familyiot-gl.cozzia.com.cn/' }];


        }
      }
      console.log('list=========>', list);
      return list;
    } },

  watch: {
    $route: {
      handler: function handler(route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true } },


  methods: {

    jumpUrl: function jumpUrl(url) {
      window.location.href = url;
    },

    jump: function jump(e) {
      var text = e.target.innerHTML;
      console.log(text);
      if (text === this.switchEnvText.test) {
        window.location.href = 'http://' + this.switchEnvUrl.test;
      }
      if (text === this.switchEnvText.dev) {
        window.location.href = 'http://' + this.switchEnvUrl.dev;
      }
      if (text === this.switchEnvText.internal) {
        window.location.href = 'http://' + this.switchEnvUrl.internal;
      }
      if (text === this.switchEnvText.overseas) {
        window.location.href = 'http://' + this.switchEnvUrl.overseas;
      }
    },
    showPwd: function showPwd() {var _this2 = this;
      if (this.passwordType === 'password') {
        this.passwordType = '';
      } else {
        this.passwordType = 'password';
      }
      this.$nextTick(function () {
        _this2.$refs.password.focus();
      });
    },
    handleLogin: function handleLogin() {var _this3 = this;
      this.$refs.loginForm.validate(function (valid) {
        if (valid) {
          _this3.loading = true;
          _this3.$store.dispatch('user/login', _this3.loginForm).then(function (res) {
            _this3.$store.dispatch('user/getRouters').then(function (res) {
              // console.log('router', this.$store.getters.$router)
              // that.$router.addRoutes(that.$store.getters.routers)
              try {
                console.log('redirect', _this3.redirect);
                _this3.handleHasPermission(res, _this3.redirect);
                _this3.redirect = '/';
              } catch (err) {
                console.log('permission', err);
              }

              _this3.$router.push({ path: _this3.redirect || '/views/dashboard/index' });
              _this3.loading = false;
            }).catch(function () {
              _this3.loading = false;
            });
          }).catch(function () {
            _this3.loading = false;
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleHasPermission: function handleHasPermission(menuList, path) {var _this4 = this;
      if (menuList && menuList.length > 0) {
        menuList.forEach(function (element) {
          if (element.child) {
            _this4.handleHasPermission(element.child, path);
          } else {
            if (element.url === path) {
              new Error('用户拥有URL权限');
            }
          }
        });
      }
    } } };exports.default = _default;